<template>
	<li :id="include.replace(/\s/g, '-')">
		<span class="include" @click="tourPopup()"  @mouseover="tourPopup()"><span v-html="include"></span> <span v-if="tour.price > 0 && tour.price < 999999" class="price">valued at ${{ tour.price }}</span></span>

		<div :style="'top: '+top+'px'" @closer="closeMe" v-if="tour" v-show="open" class="accommodation_card tour_preview">
			<div class="image" :style="'background-image: url('+tour.image_url+')'">
			</div>
			<div class="head">
				<h5>
					{{ tour.name }}
				</h5>
			</div>
			<div class="footer">
				<div class="pricetag" v-if="tour.price > 0 && tour.price < 9999999">
					<span v-if="tour.price" class="dollar">Valued at $</span>
					<span v-if="tour.price" class="value" v-text="tour.price"></span>
					<span v-if="tour.pp" class="pp">pp</span>
				</div>
			</div>
			<div class="details"><p v-html="tour.description"></p></div>
			<div class="closeMe" @click="closeMe"><svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><g transform="rotate(45 -35.355 85.355) scale(14)"><circle r="3" stroke="#fff" stroke-width=".75"/><path fill="#fff" d="M-2-.5h4v1h-4z"/><path fill="#fff" d="M-.5-2h1v4h-1z"/></g></svg></div>
		</div>

	</li>
</template>

<script>
export default {
	props:['include', 'tourName'],
	data() {
		return {
			open: false,
			tour: null,
			top: 0,
			width: 0
		}
	},
	created(){
		this.tour = _.find(Project.tours, {name: this.tourName})
		const image = new Image()
		image.src = this.tour.image_url

		window.addEventListener('resize', this.handleResize)
		this.handleResize()
	},
	mounted() {
		this.$parent.$on('closer', data => {
			this.open = false
		})
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		tourPopup() {
			if (this.width > 666){
				this.$parent.$emit('closer', true)
				this.top = -(document.getElementById(this.include.replace(/\s/g, '-')).getBoundingClientRect().top) + this.topOffset
			} else {
				this.top = 0
			}
			this.open = true
		},
		closeMe() {
			this.open = false
		},
		handleResize() {
			this.width = window.innerWidth
		}
	},
	computed: {
		topOffset(){
			if (this.width >= 1240){
				return 148
			}
			return 178
		}
	}

}
</script>

<style lang='less'>

@import '../../../../public/bower_components/3l/3L/3L.less';
@import '../../less/variables';
@import '../../less/helpers';

@keyframes slideFromLeft{
	from {
		opacity: 0;
		transform: translate(-100px, 0);
	}
	to{
		opacity: 1;
		transform: translate(0, 0);
	}
}

@keyframes slideFromTop{
	from {
		opacity: 0;
		transform: translate(0, -20px);
	}
	to{
		opacity: 1;
		transform: translate(0, 0);
	}
}

@keyframes boopRight{
	from {
		transform: translate(0, 0);
	}
	50%{
		transform: translate(@magic, 0);
	}
	to{
		transform: translate(0, 0);
	}
}

.tour_preview{
	box-shadow: -1px 2px 3px rgba(0,0,0,0.3);
	animation: slideFromTop 0.5s forwards;
	.tablet({
		animation: slideFromLeft 0.5s forwards;
		position: absolute;
		right: 0;
		width: 400px;
	});
	z-index: 4;
	padding: @magic/2 !important;
	margin: 0 0 0 -@magic;
	background: white;
	li{
		list-style: none;
	}
}

.include{
	display: inline-block;
	cursor: pointer;
	border-bottom: 2px solid @spacifica_lime;
	&:hover{
		animation: boopRight 0.2s forwards ease-in-out;
	}
}

.price{
	display: inline-block;
	font-family: @fontbold;
}

.closeMe{
	svg{
		width: @magic;
		height: @magic;
		cursor: pointer;
		fill: @red;
	}
	.mobile({
		position: absolute;
		top: 0;
		right: 0;
		svg{
			width: 40px;
			height: 40px;
		}
	});
}
</style>